<template>
  <div class='radio-group' :class='{"has-error": localErrors.length}'>
    <slot></slot>
    <x-errors-messages :errors='localErrors'></x-errors-messages>
  </div>
</template>

<script>
  import xErrorsMessages from './x-errors-messages'
  let groupId = 0

  export default {
    name: 'x-radio-group',
    props: {
      errors: {
        type: Array,
        default: () => []
      }
    },
    components: {
      'x-errors-messages': xErrorsMessages
    },
    methods: {
      updateValue (value) {
        this.localErrors = []
        this.$emit('update', value)
      }
    },

    data () {
      return {
        id: `x-radio-group-${groupId++}`,
        localErrors: []
      }
    },

    watch: {
      errors () {
        this.localErrors = this.errors
      }
    }
  }
</script>

<style lang='scss' scoped rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  .has-error {
    input {
      border-color: $color-red;
    }

    label {
      color: $color-red;
    }
  }

  .errors-messages {
    padding: 0.6rem 1.4rem;
    font-size: 1.4rem;
  }
</style>
